export default __webpack_public_path__ + "static/Card27-d045b7ef6a9fe2ae3010f0db827464c7.png";